import React, { useState } from 'react';
import { Typewriter } from 'react-simple-typewriter';
import { Button } from '../ButtonElements';

import video from '../../videos/Random tech art.mp4';
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  OpeningContentBlur,
  OpeningContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight
} from './OpenElements';

function OpenSection() {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer id='home'>
      <HeroBg>
        <VideoBg playsInline autoPlay loop muted src={video} type='video/mp4' />
      </HeroBg>
      <HeroContent>
        <OpeningContentBlur>
          <HeroH1>
          Hi, I'm Kobe Cox
          </HeroH1>
          <HeroP>
            
            <Typewriter
              words={["Welcome To My Portfolio"]}
              loop={false}
              cursor
              cursorStyle="|"
              typeSpeed={150}
              deleteSpeed={30}
              delaySpeed={5000}
            />
          </HeroP>
        </OpeningContentBlur>
        <OpeningContent>
          <HeroP>
            I’m always open to freelancing and collaborating on exciting projects! Whether you have a unique idea you’d like to bring to life or need support with a technical challenge, I’d be thrilled to help. If you have any questions about my work or would like to discuss a potential collaboration, please don’t hesitate to reach out.
          </HeroP>

          <HeroBtnWrapper>
            <Button
              to='contact'
              smooth={true}
              duration={500}
              spy={true}
              exact='true'
              offset={-80}
              primary='true'
              dark='true'
              onMouseEnter={onHover}
              onMouseLeave={onHover}
            >
              Contact Me {hover ? <ArrowForward /> : <ArrowRight />}
            </Button>
          </HeroBtnWrapper>
        </OpeningContent>
      </HeroContent>
    </HeroContainer>
  );
}

export default OpenSection;